import { Link } from "react-router-dom";

export default function Logo({ className = "", variant = "dark", to = "/" }) {
  const img = (
    <img
      src="/logo-ms-energie.png"
      alt="MS Énergie — climatisation, pompe à chaleur, chauffage, ventilation"
      className="h-11 w-auto object-contain"
    />
  );
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid="logo-link">
      {variant === "light" ? (
        <span className="bg-white rounded-xl px-3.5 py-2 inline-flex items-center shadow-sm">{img}</span>
      ) : (
        img
      )}
    </Link>
  );
}
